import { CssBaseline } from '@mui/material';
import { createTheme, ThemeOptions, ThemeProvider } from '@mui/material/styles';
import { ReactNode, useMemo } from 'react';
import breakpoints from './breakpoints';
import componentsOverride from './overrides';
import palette from './palette';
import shadows from './shadows';
import shape from './shape';
import { TThemeColor, TThemeTextColor } from './types';
import typography from './typography';

type TThemeConfigProps = {
  children: ReactNode;
  primaryColor?: TThemeColor;
  secondaryColor?: TThemeColor;
  textColor?: TThemeTextColor;
};

export default function ThemeConfig({
  children,
  primaryColor,
  secondaryColor,
  textColor,
}: TThemeConfigProps) {
  const themeOptions: ThemeOptions = useMemo(
    () => ({
      palette,
      shape,
      typography,
      breakpoints,
      direction: 'ltr',
      shadows,
    }),
    [],
  );

  if (primaryColor && themeOptions?.palette?.primary) {
    themeOptions.palette.primary = primaryColor;
  }

  if (secondaryColor && themeOptions?.palette?.secondary) {
    themeOptions.palette.secondary = secondaryColor;
  }

  if (textColor && themeOptions?.palette?.text) {
    themeOptions.palette.text = textColor;
  }

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
